import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const GeneralSettingsPage = () => {
  return (
    <Container maxWidth="xl">
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" gutterBottom>
          System Settings
        </Typography>
        <Typography variant="body1">
          System configuration and preferences
        </Typography>
      </Box>
    </Container>
  );
};

export default GeneralSettingsPage; 